import { getIn, useFormikContext } from "formik"
import { AvailableDocumentTypesFormik } from "./AvailableDocumentTypesFormik"
import { UploadDocumentFieldFormik } from "./UploadDocumentFieldFormik"
import { useMemo } from "react"
import { ImCheckboxChecked, ImCheckboxUnchecked, ImWarning } from "react-icons/im"
import { UploadImageField } from "../../../../../common/components/form/UploadImageField/UploadImageField"

type DocumentRowProps = {
  name: string
  initialData?: { type: string, content: string, verified: boolean }
}

export function DocumentRow(props: DocumentRowProps) {
  const { values, setFieldValue } = useFormikContext();
  const renterId = getIn(values, '_id')
  const theDoc = getIn(values, props.name)
  const currentType = getIn(values, `${props.name}.type`) || props.initialData?.type
  const pathToUpload = useMemo(() => `customers/${renterId}`, [renterId])

  return (
    <div className="document-row grid grid-cols-1 md:grid-cols-5 items-center">
      <AvailableDocumentTypesFormik
        className="md:col-span-3 mb-2 md:mb-0"
        name={`${props.name}.type`}
      />

      <UploadDocumentFieldFormik
        name={`${props.name}.content`}
        pathToUpload={pathToUpload}
        uploadName={currentType}
      >
        {({ src, onNewFile, onRemoveClick }) => (
          <UploadImageField
            src={src}
            onNewFile={onNewFile}
            onRemoveClick={onRemoveClick}
          />
        )}
      </UploadDocumentFieldFormik>

      <div className="md:col-start-5 md:self-start">
        <button
          onClick={() => setFieldValue(`${props.name}.verified`, !theDoc.verified)}
          type="button"
          className="w-full bg-gray/5 hover:bg-gray/10 p-2 rounded"
          disabled={!theDoc.content}
        >
          {!theDoc.content ? (
            <div className="flex gap-2 items-center justify-start text-yellowDark cursor-pointer">
              <ImWarning />
              <span className="text-brown" style={{ lineHeight: '.9' }}>Adicione o arquivo</span>
            </div>
          ) : (theDoc.verified ? (
            <div className="flex gap-2 items-center justify-start text-greenPrimary">
              <ImCheckboxChecked />
              <span>Aprovado</span>
            </div>
          ) : (
            <div className="flex gap-2 items-center justify-start text-redPrimary">
              <ImCheckboxUnchecked />
              <span>Não aprovado</span>
            </div>
          ))}
        </button>
      </div>
    </div>
  );

}
